import $ from 'jquery'
import _ from 'underscore'
import Flickity from 'flickity'
import StateManager from '../scuba/StateManager'
require('flickity-imagesloaded')

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find('.js-flickity')
    .each(function(i, el) {
      new Slider(el)
    })
})

/* --------------------------------------------------
    CLASS
-------------------------------------------------- */

function Slider() {
  this.initialize.apply(this, arguments)
}
$.extend(Slider.prototype, {
  initialize: function(el) {
    const self = this
    self.uid = _.uniqueId('scuba-')
    self.$el = $(el)
    self.$sectionContent = self.$el.closest('.js-scuba__content')
    self.flkty = new Flickity(el, {
      cellAlign: 'left',
      contain: true,
      draggable: false,
      wrapAround: true,
      pageDots: false
    })
    self.$sectionContent.on('widthChanged', self.relayout.bind(self))
    $(window).on('resize', self.relayout.bind(self))

    $(window).on(StateManager.STATE_CHANGE, function() {
      setTimeout(self.relayout.bind(self))
    })

    self.relayout.bind(self)
  },
  relayout: function() {
    var self = this
    self.flkty.resize()
  }
})



// WEBPACK FOOTER //
// ./scripts/components/Flickity.js